<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Pages'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Pages'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'title', width: '200px' },
                {
                    value: 'slug',
                    width: '200px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '200px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'pages/index',
            deleteItem: 'pages/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/pages/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/pages/add');
        }
    }
};
</script>
